import ActionClient from './ActionClient';
import HttpClient from '../../gateway/HttpClient';
import { notBlank, notUndefined } from '../../util/Assert';
import { ActionJsonModel } from '../../domain/collection/rule/action/ActionDomains';
import HttpMethod from '../../constant/HttpMethod';
import { ActionMethods } from '../../constant/MethodNames';
import { query } from '@trlogic/client-js';
import { TransactionData } from '../../domain/stream/transaction/TransactionDomains';
import { ActionType } from '../../constant/Constants';
import { WatchlistBaseModel, WatchlistEntityRequest, WatchlistGeneralRequest, WatchlistIndividualRequest } from '../../domain/watchlist/WatchlistDomains';
import SelectQuery = query.SelectQuery;

class NestActionClient implements ActionClient {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    notUndefined(httpClient, 'Http client cannot be undefined');
    this.httpClient = httpClient;
  }

  public save(action: ActionJsonModel): Promise<any> {
    notUndefined(action, 'Action cannot be undefined');
    const dto = { id: action.name, action: action };
    return this.httpClient.execute(HttpMethod.POST, ActionMethods.SAVE, dto);
  }

  public remove(id: string): Promise<any> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.DELETE, `${ActionMethods.REMOVE}/${id}`);
  }

  public deploy(id: string): Promise<any> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.POST, `${ActionMethods.DEPLOY}/${id}`);
  }

  public undeploy(id: string): Promise<any> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.POST, `${ActionMethods.UNDEPLOY}/${id}`);
  }

  public exist(id: string): Promise<boolean> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.GET, `${ActionMethods.EXIST}/${id}`);
  }

  public count(query: SelectQuery): Promise<number> {
    notUndefined(query, 'Query cannot be undefined');
    return this.httpClient.execute(HttpMethod.POST, ActionMethods.COUNT, query);
  }

  public sendAction(action: string, transaction: TransactionData): Promise<any> {
    notUndefined(action, 'Action cannot be undefined');
    const dto = { action: action, transaction: transaction };
    return this.httpClient.execute(HttpMethod.POST, ActionMethods.SEND, dto);
  }

  public sendKycAction(
    action: string,
    request: WatchlistIndividualRequest | WatchlistEntityRequest | WatchlistGeneralRequest,
    response: WatchlistBaseModel[],
  ): Promise<any> {
    const dto = { action, request, response };
    return this.httpClient.execute(HttpMethod.POST, ActionMethods.SEND_KYC, dto);
  }

  public bulkAction(ids: string[], type: ActionType): Promise<{ id: string; error: any }[]> {
    const payload = { ids, type };
    return this.httpClient.execute(HttpMethod.POST, ActionMethods.BULK_ACTION, payload);
  }
}

export default NestActionClient;
